<template>
  <GoogleMapLoader
    :mapConfig="mapConfig"
    :apiKey="apiKey"
    style="width: 100% !important"
  >
    <template slot-scope="{ google, map }">
      <GoogleMapLine
        v-for="line in poligonosNuevo"
        :key="line.identificadorPoligono"
        :google="google"
        :map="map"
        :graphicPolygon="line"
      />

      <GoogleMapCircle
        v-for="circulo in circulosNuevo"
        :key="circulo.identificadorCirculo"
        :google="google"
        :map="map"
        :graphicCircle="circulo"
      />
    </template>
  </GoogleMapLoader>
</template>

<script>
import GoogleMapLoader from "./GoogleMapLoader";
import GoogleMapMarker from "./GoogleMapMarker";
import GoogleMapLine from "./GoogleMapLine";
import GoogleMapCircle from "./GoogleMapCircle";
import { mapSettings } from "../constants/mapSettings";
import { Fragment } from "vue-fragment";

export default {
  name: "TravelMAp",
  components: {
    GoogleMapLoader,

    GoogleMapLine,
    GoogleMapCircle,
    Fragment,
  },
  
  data() {
    return {
      circulos: [],
      poligonos: [],
      apiKey: process.env.VUE_APP_GOOGLE_KEY,
    };
  },
  watch: {
  },
  computed: {
    poligonosNuevo() {
      return this.$store.state.elementosMapaSig.poligonos;
    },

    circulosNuevo() {
      return this.$store.state.elementosMapaSig.circulos;
    },

    mapConfig() {
      return {
        ...mapSettings,
        center: this.$store.state.elementosMapaSig.centroMapa,
        zoom: this.$store.state.elementosMapaSig.zoom ?? 15, 
      };
    },
  },
  methods: {
    
  },
};
</script>
